<template>
  <div class="modal fade light " id="modalCashbackForm" ref="bank" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-background modal-lg">
      <div class="modal-content">
        <div class=" ">
          <header class="modal-card-head">
            <p class="modal-card-title">เครดิตเงินคืน</p><button aria-label="close" data-dismiss="modal"
              class="delete"></button>
          </header>
          <section class="modal-card-body">

            <div class="modal-body -modal-body text-center">

              <label data-v-630250ce="">ยอดสะสมคืนยอดเสีย</label>

              <h5 class="cashbacknb">
                {{ UserInfo.internalWallet.cashbackWallet }} บาท
              </h5><br /><br />
              <button type="button" class="button full-50 is-primary" @click="getRolling()">
                <span>รับ CASHBACK</span>
              </button>
              <hr class="cashbackhr">

            </div>
          </section>
        </div>
      </div>
    </div>
  </div>




</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { UserInfoMixins } from '@/mixins/UserInfo.js'
import { PrefixMixins } from '@/mixins/Prefix.js'

import { fetchCaskback, Rolling } from '@/services/modules/cashback.js'
import moment from 'moment'

export default {
  name: 'CashBackForm',
  mixins: [UserInfoMixins, PrefixMixins],

  data() {
    return {
      CashBackHistory: [],
    }
  },

  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
      'getPrefix',
    ]),
  },
  methods: {
    getDate: function (data) {
      return moment(data).format('DD MMMM YYYY, h:mm:ss a')
    },

    async getRolling() {
      await Rolling(this.UserInfo.internalWallet.cashbackWallet, (res) => {
        if (res.status) {
          this.$swal.fire('Success!', '', 'success')
        } else {
          this.$swal.fire(res.message, '', 'error')
        }
      })
    },
    async fetchDeposit() {
      await fetchCaskback((res) => {
        if (res.status) {
          this.CashBackHistory = res.data
        }
      })
    },
  },
  async mounted() {
    await this.fetchDeposit()
  },
}
</script>
<style scoped>
.modal-dialog .modal-content[data-v-6c8d75ed] {
  background-color: #151515;
  border-radius: 10px;
  box-shadow: 0 0 5px #000;
}

.modal-dialog .modal-content .modal-body .header-label[data-v-6c8d75ed] {
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  padding: 0.8rem 0.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(180deg, #a44bc9, #6200b5);
  border-radius: 4px;
}

.modal-dialog .modal-content .modal-header .btn-close[data-v-6c8d75ed] {
  color: #fff;
  background: none;
  width: auto;
  height: auto;
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(var(--bs-modal-header-padding-y) * -0.5) calc(var(--bs-modal-header-padding-x) * -0.5) calc(var(--bs-modal-header-padding-y) * -0.5) auto;
}

.modal-dialog .modal-content .modal-header[data-v-6c8d75ed] {
  color: #fff;
  border-bottom: none;
  padding: 0.225rem 0.5rem;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-dialog .modal-content .modal-body[data-v-6c8d75ed] {
  padding-top: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

#cashback .blog-cashback[data-v-4ad267e1] {
  padding: 1rem 1rem 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
}

.blog-data-amount h2[data-v-4ad267e1] {
  color: #f7ac03;
  font-weight: 600;
  font-size: 2.5rem;
  margin: 0;
}

table,
td,
th {
  border: 1px solid;
  padding: 5px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/CashBackForm.vue